import React, { useState } from 'react';
import style from './index.module.css';
import closeeye from '../../../Assets/closeeye.svg';
import eye from '../../../Assets/eye.svg';
import danger from '../../../Assets/danger.svg';

const Password = ({ handleChange, input }) => {
  const [passwordType, setPasswordType] = useState(true);
  const [confirmpasswordType, setconfirmpasswordType] = useState(true);

  const togglePassword = () => {
    setPasswordType(!passwordType);
  };

  const togglePassword1 = () => {
    setconfirmpasswordType(!confirmpasswordType);
  };
  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
  return (
    <div>
      <div className={style.iconInput}>
        <div className={style.passwordEyeIcon}>
          <input
            type={!passwordType ? 'text' : 'password'}
            name='createPassword'
            placeholder='Create Password'
            value={input.createPassword}
            onChange={handleChange}
            autoComplete='off'
          />
          <img
            src={!passwordType ? eye : closeeye}
            alt='eyeIcon'
            onClick={togglePassword}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </div>
      <div className={style.iconInput}>
        <div className={style.passwordEyeIcon}>
          <input
            type={!confirmpasswordType ? 'text' : 'password'}
            name='password'
            placeholder='Confirm password'
            value={input.password}
            onChange={handleChange}
            autoComplete='off'
          />
          <img
            src={!confirmpasswordType ? eye : closeeye}
            alt='eyeIcon'
            onClick={togglePassword1}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </div>
      <div className={style.iconInput1}>
        {!passwordRegex.test(input.password) && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={danger} alt='' />
            Password must contain at least 8 characters including uppercase,
            lowercase and numbers
          </div>
        )}
        {/* {input.password !== input.createPassword && (
          <p>Passwords do not match!</p>
        )} */}
      </div>
    </div>
  );
};

export default Password;

// else if (!passwordRegex.test(input.password)) {
//   Swal.fire({
//     icon: 'warning',
//     text: 'Password must contain at least 8 characters, including UPPER/lowercase and numbers!',
//     timer: 2000,
//   });
//   return;
// }


